import { render } from "./_Roles.vue?vue&type=template&id=adbaf67a"
import script from "./_Roles.vue?vue&type=script&lang=js"
export * from "./_Roles.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\34\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__